import { ModalController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detail-offre',
  templateUrl: './detail-offre.component.html',
  styleUrls: ['./detail-offre.component.scss'],
})
export class DetailOffreComponent implements OnInit {
@Input() offre;
  constructor(private modalController: ModalController) { }

  ngOnInit() {
    console.log('offre: ', this.offre);
  }
  close(data?) {
    this.modalController.dismiss(data);
  }

}
